const colorPallete = {
  primary: '#245AD3',
  accent: '#A41E39',
  secondary: '#30736D'
};

export { colorPallete };
